import Share from './Share'

export default Share
// eslint-disable-next-line import/export
export * from './Share'
